import React from 'react';
import { Warning } from '@phosphor-icons/react';

export const isPreviewHost = () => /\.preview\.emergentagent\.com$|^localhost$/.test(window.location.hostname);

export const PreviewBanner = () => {
  if (!isPreviewHost()) return null;
  return (
    <div className="fixed bottom-16 md:bottom-0 inset-x-0 z-[60] pointer-events-none bg-red-600/95 text-white text-[11px] sm:text-xs font-bold tracking-wide text-center py-1 px-2 flex items-center justify-center gap-1.5" data-testid="preview-env-banner">
      <Warning size={14} weight="fill" />
      ΔΟΚΙΜΑΣΤΙΚΟ ΠΕΡΙΒΑΛΛΟΝ (PREVIEW) – ΟΙ ΚΑΤΑΧΩΡΙΣΕΙΣ ΕΔΩ ΔΕΝ ΕΜΦΑΝΙΖΟΝΤΑΙ ΣΤΟ LIVE
    </div>
  );
};
